import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import English from 'resources/locales/en'


i18n.use(initReactI18next)
  .init({
    resources:{
      "en" : English
    },
    lng: 'en',
    debug: true,
  });


export default i18n;
